// import React from 'react';
// import { MessageCircle } from 'lucide-react';
// import { siteInfo } from '../data/mock';

// const WhatsAppButton = () => {
//   const handleClick = () => {
//     const message = encodeURIComponent('Hallo, ik wil graag meer informatie over de rijlessen.');
//     window.open(`https://wa.me/${siteInfo.whatsapp.replace(/\s/g, '')}?text=${message}`, '_blank');
//   };

//   return (
//     <button
//       onClick={handleClick}
//       className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-40"
//       aria-label="Contact via WhatsApp"
//     >
//       <MessageCircle className="w-6 h-6" />
//     </button>
//   );
// };

// export default WhatsAppButton;

// import React, { useState } from 'react';
// import { MessageCircle, X } from 'lucide-react';
// import { siteInfo } from '../data/mock';

// const WhatsAppButton = () => {
//   const [open, setOpen] = useState(false);

//   const openWhatsApp = () => {
//     const message = encodeURIComponent(
//       'Hallo, ik heb een vraag over rijlessen.'
//     );
//     window.open(
//       `https://wa.me/${siteInfo.whatsapp.replace(/\s/g, '')}?text=${message}`,
//       '_blank'
//     );
//   };

//   return (
//     <div className="fixed bottom-6 right-6 z-40">
//       {open && (
//         <div className="mb-3 bg-white rounded-xl shadow-lg p-4 w-64 animate-fade-in">
//           <div className="flex justify-between items-center mb-2">
//             <p className="font-semibold">Support via WhatsApp</p>
//             <button onClick={() => setOpen(false)}>
//               <X size={16} />
//             </button>
//           </div>
//           <p className="text-sm text-gray-600 mb-3">
//             Heb je vragen over rijlessen of pakketten?
//           </p>
//           <button
//             onClick={openWhatsApp}
//             className="w-full bg-green-500 hover:bg-green-600 text-white py-2 rounded-lg"
//           >
//             Chat starten
//           </button>
//         </div>
//       )}

//       <button
//         onClick={() => setOpen(!open)}
//         className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110"
//         aria-label="WhatsApp support"
//       >
//         <MessageCircle className="w-6 h-6" />
//       </button>
//     </div>
//   );
// };

// export default WhatsAppButton;

import React, { useState } from 'react';
import { MessageCircle, Phone, Mail, X } from 'lucide-react';
import { siteInfo } from '../data/mock';

const SupportButton = () => {
  const [open, setOpen] = useState(false);

  const handleWhatsApp = () => {
    const message = encodeURIComponent('Hallo, ik heb een vraag over rijlessen.');
    window.open(
      `https://wa.me/${siteInfo.whatsapp.replace(/\s/g, '')}?text=${message}`,
      '_blank'
    );
  };

  const handleCall = () => {
    window.open(`tel:${siteInfo.phone}`, '_self');
  };

  const handleEmail = () => {
    window.open(`mailto:${siteInfo.email}`, '_self');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {open && (
        <div className="mb-3 w-64 bg-white rounded-xl shadow-lg p-4 animate-fade-in">
          <div className="flex justify-between items-center mb-3">
            <p className="font-semibold text-gray-800">Support</p>
            <button onClick={() => setOpen(false)}>
              <X size={18} />
            </button>
          </div>

          <button
            onClick={handleWhatsApp}
            className="flex items-center gap-2 w-full mb-2 bg-green-500 hover:bg-green-600 text-white py-2 px-3 rounded-lg transition-all"
          >
            <MessageCircle size={18} /> WhatsApp
          </button>

          <button
            onClick={handleCall}
            className="flex items-center gap-2 w-full mb-2 bg-blue-500 hover:bg-blue-600 text-white py-2 px-3 rounded-lg transition-all"
          >
            <Phone size={18} /> Bel ons
          </button>

          <button
            onClick={handleEmail}
            className="flex items-center gap-2 w-full bg-gray-500 hover:bg-gray-600 text-white py-2 px-3 rounded-lg transition-all"
          >
            <Mail size={18} /> E-mail
          </button>
        </div>
      )}

      <button
        onClick={() => setOpen(!open)}
        className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110"
        aria-label="Support menu"
      >
        <MessageCircle className="w-6 h-6" />
      </button>
    </div>
  );
};

export default SupportButton;
